export default __webpack_public_path__ + "static/media/vadim.daba2313.png";